var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFontsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2797 3.16176H10.1179V4.42647H13.2797C13.4474 4.42647 13.6082 4.49309 13.7268 4.61168C13.8454 4.73027 13.912 4.89111 13.912 5.05882V6.32353H11.3826C10.8796 6.32403 10.3974 6.52406 10.0417 6.87972C9.68607 7.23538 9.48604 7.71761 9.48554 8.22059V8.85294C9.48604 9.35592 9.68607 9.83815 10.0417 10.1938C10.3974 10.5495 10.8796 10.7495 11.3826 10.75H15.1767V5.05882C15.1762 4.55585 14.9762 4.07361 14.6205 3.71795C14.2649 3.3623 13.7826 3.16227 13.2797 3.16176V3.16176ZM11.3826 9.48529C11.2149 9.48529 11.054 9.41867 10.9355 9.30008C10.8169 9.18149 10.7502 9.02065 10.7502 8.85294V8.22059C10.7502 8.05288 10.8169 7.89204 10.9355 7.77345C11.054 7.65486 11.2149 7.58824 11.3826 7.58824H13.912V9.48529H11.3826ZM7.58848 10.75H8.85319L5.05907 0H3.79436L0.000244141 10.75H1.26495L2.33616 7.58824H6.51791L7.58848 10.75ZM2.76426 6.32353L4.34324 1.66246H4.51145L6.0898 6.32353H2.76426Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontsIcon);
export default __webpack_public_path__ + "static/media/fontsIcon.f58617a5.svg";
export { ForwardRef as ReactComponent };